import { getToolSideList } from '../data';

export const isOrganizeTool = (t: any, tool: string) => {
  const toolSideList = getToolSideList(t);
  const organizeCategory = toolSideList.find(
    (category) => category.key === 'organize'
  );

  if (organizeCategory?.subMenu) {
    return organizeCategory.subMenu.some((subTool) => subTool.link === tool);
  }
  return false;
};
